import { render, staticRenderFns } from "./baiguullaga_follow_btn.vue?vue&type=template&id=6a4be3d3&scoped=true&"
import script from "./baiguullaga_follow_btn.vue?vue&type=script&lang=js&"
export * from "./baiguullaga_follow_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4be3d3",
  null
  
)

export default component.exports